<template>
  <component :is="strong ? 'strong' : 'span'">
    <span class="ltr">
      <span v-if="operand">
        {{ operand }}
      </span>
      <span>{{ displayPrice(price) }}</span>
    </span>
  </component>
</template>

<script setup lang="ts">
import type { Price } from '~/types';

defineProps<{
  price: number | Price;
  operand?: '+' | '−';
  strong?: boolean;
}>();
const { displayPrice } = useFormat();
</script>

<style scoped>
span, strong {
  unicode-bidi: plaintext;
  text-wrap: nowrap;
}
</style>